import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import loadingAnimationSvg from '../../images/loading.svg';
import Icon from './Icon';

export default class TransactionStatus extends Component {
  render () {
    return (<span className="c-transaction-status">{this.renderIcon()}</span>);
  }

  renderIcon () {
    if (this.props.status === true) {
      return (<Icon code="tick" className="c-transaction-status__success"/>);
    }

    if (this.props.status === false) {
      return (<Icon code="delete" className="c-transaction-status__failure"/>);
    }

    return (<ReactSVG data-tip="Waiting for transaction to get mined!" src={loadingAnimationSvg}/>);
  }
}


// WEBPACK FOOTER //
// ./src/components/Components/TransactionStatus.js